/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.panel()
    export class AgentdivisionsDialog extends NoboxEntityDialog<AgentdivisionsRow, any> {
        protected getFormKey() { return AgentdivisionsForm.formKey; }
        protected getIdProperty() { return AgentdivisionsRow.idProperty; }
        protected getLocalTextPrefix() { return AgentdivisionsRow.localTextPrefix; }
        protected getNameProperty() { return AgentdivisionsRow.nameProperty; }
        protected getService() { return AgentdivisionsService.baseUrl; }
        protected getDeletePermission() { return AgentdivisionsRow.deletePermission; }
        protected getInsertPermission() { return AgentdivisionsRow.insertPermission; }
        protected getUpdatePermission() { return AgentdivisionsRow.updatePermission; }

        protected form = new AgentdivisionsForm(this.idPrefix);
        private agentsGrid: UserAgentGrid;
        protected save() {
            super.save();
        }
        constructor(container?: JQuery) {
            super(container);
            this.agentsGrid = new UserAgentGrid(this.byId('AgentsGrid'));
            this.agentsGrid.openDialogsAsPanel = true;
        }
        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }
        loadEntity(entity: AgentdivisionsRow) {
            super.loadEntity(entity);
            if (this.isNewOrDeleted()) {
                this.byId('AgentGrid').hide();
                this.form.In.element.closest('.category').toggle(false);
                this.form.Container.element.closest('.category').toggle(false);
            }
            if (this.isEditMode()) {
                this.element.find(".add-button-agent").toggle(true);
                this.agentsGrid.listId = `${entity.Id}`;
            }
        }
        protected updateInterface() {
            super.updateInterface();
        }
        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            var $this = this;
            buttons.push({
                title: "Add Agents",
                icon: "fa-users text-blue",
                cssClass: "add-button-agent",
                visible: false,
                separator: true,
                onClick: () => {
                    var dlg = new AgentPickerDialog({
                        hideProducts: this.get_entityId()
                    });
                    dlg.onSuccess = (selected) => {
                        // filter already existing products
                        selected = selected.filter(x => !Q.any($this.agentsGrid.getItems(), y => y.DivisionIds == x.DivisionIds));

                        var listReq = <Serenity.SaveRequest<Nobox.Administration.UserRow>[]>[];
                        //for (var sel of selected) {
                        //    if (sel.DivisionIds != null) {
                        //        sel.DivisionIds += `,${this.get_entityId()}`;
                        //    } else {
                        //        sel.DivisionIds = `${this.get_entityId()}`;
                        //    }
                        //    listReq.push({
                        //        Entity: sel
                        //    });
                        //}
                        //Q.serviceCall({
                        //    blockUI: false,
                        //    service: "/Services/Administration/User/Save",
                        //    request: listReq,
                        //    onSuccess: function (res) {
                        //        Q.notifySuccess(`Success Add ${res.CustomData.Update} agent to this division`);
                        //        $this.agentsGrid.refresh();
                        //    },
                        //    onError: function (error) {
                        //        Q.notifyError("Error add contact to this division")
                        //    }
                        //})
                        return true;
                    };
                    dlg.dialogOpen();
                }
            });
            return buttons;
        }
        getTemplate() {
            return `<div class="s-DialogContent">
                        <div id="~_Toolbar" class="s-DialogToolbar">
                        </div>
                        <div class="s-Form">
                            <form id="~_Form" action="">
                                <div class="fieldset">
                                    <div id="~_PropertyGrid"></div>
                                    <div class="clear"></div>
                                </div>
                            </form>
                            <div id="~_AgentsGrid"></div>
                        </div>
                    </div>`;
        }

    }
}